'use client';

import { ComponentPropsWithoutRef, MouseEvent, useRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './overlay.scss';

type Props = {
    isClosing?: boolean;
} & ComponentPropsWithoutRef<'div'>;
export const Overlay = ({ children, onClick, isClosing, className }: Props) => {
    const overlayRef = useRef<HTMLDivElement>(null);
    const mouseDownTargetRef = useRef<EventTarget | null>(null);

    const handleMouseDown = (e: MouseEvent<HTMLDivElement>) => {
        mouseDownTargetRef.current = e.target;
    };
    const handleClick = (e: MouseEvent<HTMLDivElement>) => {
        if (e.target === mouseDownTargetRef.current && e.target === overlayRef.current) {
            onClick?.(e);
        }
        mouseDownTargetRef.current = null;
    };

    return (
        <div className={cn('overlay__wrapper', isClosing && 'overlay__wrapper--closing', className)}>
            <div ref={overlayRef} className={'overlay'} onClick={handleClick} onMouseDown={handleMouseDown}>
                {children}
            </div>
        </div>
    );
};
